export enum TextEmphasisAvailability {
  UNAVAILABLE,
  DISABLED,
  ALLOWED,
}
